module.exports = __webpack_public_path__ + "static/media/UltradentLogo.1dccd809.png";